import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { Button } from 'react-bootstrap';
import styles from "./ChangeUserInfoModal.module.scss";

var LearnLessonDone = function LearnLessonDone(props) {
  var toggle = props.toggle,
      show = props.show,
      name = props.name;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Modal, {
      isOpen: show,
      toggle: toggle,
      className: styles.container,
      children: /*#__PURE__*/_jsx(ModalBody, {
        className: styles.modalBody,
        children: /*#__PURE__*/_jsxs("div", {
          className: "d-flex flex-column justify-content-center p-4",
          children: [/*#__PURE__*/_jsxs("p", {
            children: ["You have already finished ", name && name.item && name.item.LessonName, " and cant play it in learn mode again"]
          }), /*#__PURE__*/_jsx("p", {
            children: "Try playing it in Start"
          }), /*#__PURE__*/_jsx(Button, {
            onClick: toggle,
            children: "Close"
          })]
        })
      })
    })
  });
};

export default LearnLessonDone;